import React, { useMemo } from "react";
import styles from './Questionnaire.module.css';
import Question from "../questions/Question";

// Questionnaire component
function Questionnaire({ questions, handleAnswerChange, answers, marked }) {
  // Create a map of questions for easy lookup by id
  const questionMap = useMemo(() => {
    const map = {};
    for (const question of questions) {
      map[question.id] = question;
    }
    return map;
  }, [questions]);

  // Render the list of questions
  return (
    <div className={styles.questionnaire}>
      {questions.map((question) => (
        <div className={styles.questionWrapper} key={question.id}>
          <Question
            data={question}
            handleAnswerChange={handleAnswerChange}
            answers={answers}
            questionMap={questionMap}
            isMarked={marked.includes(question.id)}
          />
        </div>
      ))}
    </div>
  );
}

export default Questionnaire;
